<template>
  <div class="fill-in-blank">
    <h5 v-html="(active+1) +'.'+ data[active].examcont +'（'+ data[active].scores+'分）' "> </h5>
   <div style="height: 100px;width: 100%;padding: .625rem;">
    <van-cell-group>
    <div  >
    </div>
    </van-cell-group>
   </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in data[active].examan" v-html="x<data[active].examan.length-1?a.optioncontent+',':a.optioncontent"></a> </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="data[active].gradestand"></a> </div>
    <div style="height: 100px;width: 100%" ></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.fill-in-blank{
  .items{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .item{
      display: flex;
      flex-wrap: wrap;
      input{
        border: none;
        border-bottom: 1px solid rgb(204, 203, 203);
        width: 3.75rem;
        text-align: center;
        padding: 0 .625rem;
        margin: 0 .3125rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/cuotijicomm/fillIn.vue